// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1vMDV","Open":"SideDrawer_Open__2VwrC","Close":"SideDrawer_Close__2gkfg","Logo":"SideDrawer_Logo__30C36"};